import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { useMemo } from 'react';
import { PointerSensor, useSensor, DndContext, DragEndEvent } from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

type TFileList = UploadFile[];
interface IProps {
  value?: TFileList;
  onChange?: (fileList: TFileList) => void;
  maxCount?: number;
}

const DraggableUploadListItem = ({ originNode, file }: {
  originNode: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
  file: UploadFile
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: file.uid,
  });

  const style = {
    transform: CSS.Translate?.toString?.(transform),
    transition,
    cursor: 'move',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      // prevent preview event when drag end
      className={isDragging ? 'is-dragging' : ''}
      {...attributes}
      {...listeners}
    >
      {/* hide error tooltip when dragging */}
      {file.status === 'error' && isDragging ? originNode.props.children : originNode}
    </div>
  );
};

const uploadImage = (props: IProps) => {
  const fileList: TFileList = useMemo(() => {
    return props.value || [];
  }, [props.value]);

  const handleUploadChange = (info: UploadChangeParam) => {
    props.onChange?.(info.fileList)
  };

  const maxCount = useMemo(() => {
    return props.maxCount ?? 1;
  }, [props.maxCount]);

  const multiple = useMemo(() => {
    return maxCount > 1;
  }, [maxCount]);


  const sensor = useSensor(PointerSensor, {
    activationConstraint: { distance: 10 },
  });
  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
      const prev = fileList;
      const activeIndex = prev.findIndex(i => i.uid === active.id);
      const overIndex = prev.findIndex(
        i => i.uid === (over === null || over === void 0 ? void 0 : over.id),
      );
      const newList = arrayMove(prev, activeIndex, overIndex);
      handleUploadChange({
        fileList: newList
      } as any)
    }
  };

  return (
    <DndContext sensors={[sensor]} onDragEnd={onDragEnd}>
      <SortableContext items={fileList.map(i => i.uid)} strategy={verticalListSortingStrategy}>
        <Upload
          listType="picture"
          accept="image/*"
          beforeUpload={() => false}
          fileList={fileList}
          onChange={handleUploadChange}

          maxCount={maxCount}
          multiple={multiple}
          itemRender={(originNode, file) => (
            <DraggableUploadListItem originNode={originNode} file={file} />
          )}
        >
          <Button icon={<UploadOutlined />}>上传封面</Button>
        </Upload>
      </SortableContext>
    </DndContext>

  );
};

export default uploadImage;
